/** A non-2xx response from an endpoint, carrying its HTTP status (e.g. 412 for a failed precondition). */
export class HttpError extends Error {
    constructor(message: string, readonly status: number) {
        super(message);
        this.name = 'HttpError';
    }
}
